import { recordSuccessfulLoadboardConnection } from '../api/loadboards.api'
import type { ConnectionAttempt } from './sourceAnalytics'

/**
 * Persist the authoritative connection sequence before completing the analytics attempt.
 * The request remains best-effort and does not delay the successful UI transition.
 */
export const completeSuccessfulConnectionAttempt = (board: string, attempt: ConnectionAttempt, onSettled?: () => void): void => {
    attempt.recordStep('connection_verify', 'succeeded')
    void attempt.registrationPromise
        .then(() =>
            recordSuccessfulLoadboardConnection(board, {
                attemptStartedAt: attempt.startedAt,
                connectionAttemptId: attempt.attemptId,
                connectionFlowId: attempt.connectionFlowId,
                connectionMethod: attempt.connectionMethod,
            })
        )
        .then((connectionSequence) =>
            attempt.complete('success', connectionSequence !== undefined && connectionSequence > 0 ? { connectionSequence } : undefined)
        )
        .catch(() => {
            // The product connection already succeeded, so analytics remains best-effort. Keep
            // the failure visible without exposing the request (which may contain credentials).
            console.warn('[Load Hub] Failed to persist the successful connection sequence', { loadboard: board })
            attempt.complete('success')
        })
        .finally(() => onSettled?.())
}
